var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-788.5-98a31.3,31.3,0,0,1-12.261-2.475,31.4,31.4,0,0,1-10.013-6.751,31.394,31.394,0,0,1-6.751-10.013A31.3,31.3,0,0,1-820-129.5a31.3,31.3,0,0,1,2.475-12.261,31.394,31.394,0,0,1,6.751-10.013,31.4,31.4,0,0,1,10.013-6.751A31.3,31.3,0,0,1-788.5-161a31.3,31.3,0,0,1,12.261,2.475,31.4,31.4,0,0,1,10.013,6.751,31.4,31.4,0,0,1,6.751,10.013A31.3,31.3,0,0,1-757-129.5a31.3,31.3,0,0,1-2.475,12.261,31.4,31.4,0,0,1-6.751,10.013,31.4,31.4,0,0,1-10.013,6.751A31.3,31.3,0,0,1-788.5-98ZM-805-133a5.006,5.006,0,0,0-5,5,5.006,5.006,0,0,0,5,5h33a5.006,5.006,0,0,0,5-5,5.006,5.006,0,0,0-5-5Z",
    transform: "translate(820 161)",
    fill: "#ff8d73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStop);
export default __webpack_public_path__ + "static/media/red-stop.8df1485ebe4fd8c265fd6984aad7fad0.svg";
export { ForwardRef as ReactComponent };